module.exports = __webpack_public_path__ + "img/rural3.406e0cc0.jpg";